/**
 * LK Custom JavaScript
 * Účel: Custom JavaScript funkce pro Shopify theme
 * Datum vytvoření: 2026-07-30
 */

/**
 * SELLEASY PRICE UPDATER
 * Aktualizuje cenu produktu na product detail page když uživatel vybere extras
 */

(function() {
  'use strict';

  // Konfigurace
  const CONFIG = {
    priceSelector: '.product-single__price',
    priceContentSelector: '[itemprop="price"]',
    selleasyWidgetSelector: '.lb-widget-pac',
    selleasyCheckboxSelector: '.lb-card-checkbox',
    selleasyProductCardSelector: 'lb-upsell-long-card',
    priceAttributeName: 'lb-default-price'
  };

  let originalPrice = 0;
  let priceElement = null;
  let priceContentElement = null;
  let priceFormat = {
    symbol: '€',
    symbolBefore: true,
    decimalSeparator: ','
  };

  /**
   * Inicializace price updater
   */
  function init() {
    // Najít price elementy
    priceElement = document.querySelector(CONFIG.priceSelector);
    priceContentElement = document.querySelector(CONFIG.priceContentSelector);

    if (!priceElement || !priceContentElement) {
      console.warn('LK Custom JS: Price elements not found');
      return;
    }

    // Uložit originální cenu z content atributu (v eurech, např. "52.95")
    const contentPrice = priceContentElement.getAttribute('content');
    originalPrice = parseFloat(contentPrice) || 0;

    if (originalPrice === 0) {
      console.warn('LK Custom JS: Could not parse original price');
      return;
    }

    // Detekovat formát měny z originálního textu
    detectPriceFormat();

    console.log('LK Custom JS: Original price stored:', originalPrice);
    console.log('LK Custom JS: Price format detected:', priceFormat);

    // Čekat na Selleasy widget (může se načítat asynchronně)
    waitForSelleasyWidget();
  }

  /**
   * Detekuje formát měny z originálního price textu
   */
  function detectPriceFormat() {
    const originalText = priceElement.textContent.trim();

    // Extrahovat číslo a zbytek (měnový symbol)
    const numberMatch = originalText.match(/[\d.,]+/);
    if (!numberMatch) return;

    const numberPart = numberMatch[0];
    const symbolPart = originalText.replace(numberPart, '').trim();

    // Uložit měnový symbol
    if (symbolPart) {
      priceFormat.symbol = symbolPart;
    }

    // Detekovat pozici symbolu (před nebo za číslem)
    priceFormat.symbolBefore = originalText.indexOf(numberPart) > 0;

    // Detekovat desetinný separator (čárka nebo tečka)
    if (numberPart.includes(',')) {
      priceFormat.decimalSeparator = ',';
    } else if (numberPart.includes('.')) {
      priceFormat.decimalSeparator = '.';
    }
  }

  /**
   * Čeká na načtení Selleasy widgetu a checkboxů
   */
  function waitForSelleasyWidget() {
    const widget = document.querySelector(CONFIG.selleasyWidgetSelector);

    if (widget) {
      console.log('LK Custom JS: Selleasy widget found, waiting for checkboxes...');
      // Widget existuje, čekat na checkboxy uvnitř
      waitForCheckboxes(widget);
    } else {
      console.log('LK Custom JS: Waiting for Selleasy widget...');
      // Widget ještě neexistuje, použít MutationObserver
      const observer = new MutationObserver(function(mutations) {
        const widget = document.querySelector(CONFIG.selleasyWidgetSelector);
        if (widget) {
          console.log('LK Custom JS: Selleasy widget appeared');
          observer.disconnect();
          waitForCheckboxes(widget);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Timeout po 15 sekundách
      setTimeout(function() {
        observer.disconnect();
        console.warn('LK Custom JS: Selleasy widget not found after 15 seconds');
      }, 15000);
    }
  }

  /**
   * Čeká na načtení checkboxů uvnitř widgetu
   * @param {Element} widget - Selleasy widget element
   */
  function waitForCheckboxes(widget) {
    let attempts = 0;
    const maxAttempts = 20; // 20 pokusů = 10 sekund (každých 500ms)

    function tryFindCheckboxes() {
      attempts++;
      const checkboxes = widget.querySelectorAll(CONFIG.selleasyCheckboxSelector);

      if (checkboxes.length > 0) {
        console.log('LK Custom JS: Checkboxes found on attempt', attempts);
        initializeSelleasyListeners();
        return;
      }

      if (attempts < maxAttempts) {
        console.log('LK Custom JS: Checkboxes not found yet, attempt', attempts + '/' + maxAttempts);
        setTimeout(tryFindCheckboxes, 500);
      } else {
        console.warn('LK Custom JS: Checkboxes not found after', maxAttempts, 'attempts');
      }
    }

    // Spustit první pokus
    tryFindCheckboxes();

    // Také sledovat změny v DOM widgetu
    const observer = new MutationObserver(function(mutations) {
      const checkboxes = widget.querySelectorAll(CONFIG.selleasyCheckboxSelector);
      if (checkboxes.length > 0 && attempts < maxAttempts) {
        console.log('LK Custom JS: Checkboxes detected via MutationObserver');
        observer.disconnect();
        attempts = maxAttempts; // Zastavit retry loop
        initializeSelleasyListeners();
      }
    });

    observer.observe(widget, {
      childList: true,
      subtree: true
    });

    // Odpojit observer po 15 sekundách
    setTimeout(function() {
      observer.disconnect();
    }, 15000);
  }

  /**
   * Inicializuje event listeners na Selleasy checkboxy
   */
  function initializeSelleasyListeners() {
    console.log('LK Custom JS: Initializing Selleasy listeners');

    // Najít všechny checkboxy
    const checkboxes = document.querySelectorAll(CONFIG.selleasyCheckboxSelector);

    if (checkboxes.length === 0) {
      console.warn('LK Custom JS: No Selleasy checkboxes found during initialization');
      return;
    }

    console.log('LK Custom JS: Found', checkboxes.length, 'checkboxes - attaching event listeners');

    // Přidat event listener na každý checkbox
    checkboxes.forEach(function(checkbox, index) {
      checkbox.addEventListener('change', updatePrice);
      console.log('LK Custom JS: Event listener attached to checkbox', index + 1);
    });

    // Také sledovat změny v DOM (pro dynamicky přidané checkboxy)
    const widget = document.querySelector(CONFIG.selleasyWidgetSelector);
    if (widget) {
      const observer = new MutationObserver(function() {
        updatePrice();
      });

      observer.observe(widget, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'checked']
      });

      console.log('LK Custom JS: MutationObserver active for widget changes');
    }

    console.log('LK Custom JS: ✅ Initialization complete!');
  }

  /**
   * Aktualizuje cenu produktu na základě vybraných extras
   */
  function updatePrice() {
    // Získat všechny product cards
    const productCards = document.querySelectorAll(CONFIG.selleasyProductCardSelector);
    let totalExtrasPrice = 0;
    let selectedCount = 0;

    productCards.forEach(function(card, index) {
      // Selleasy používá atribut 'lb-selected' místo checkbox.checked
      const isSelected = card.hasAttribute('lb-selected');

      if (isSelected) {
        // Najít span s cenou uvnitř karty (cena není na kartě samotné)
        const priceSpan = card.querySelector('[' + CONFIG.priceAttributeName + ']');

        if (priceSpan) {
          // Získat cenu z atributu (v centech)
          const priceInCents = parseInt(priceSpan.getAttribute(CONFIG.priceAttributeName)) || 0;
          // Převést na eura
          const priceInEuros = priceInCents / 100;
          totalExtrasPrice += priceInEuros;
          selectedCount++;

          console.log('LK Custom JS: Card', index + 1, 'selected - Price:', priceInEuros, 'EUR');
        } else {
          console.warn('LK Custom JS: Card', index + 1, 'selected but price span not found');
        }
      }
    });

    // Vypočítat celkovou cenu
    const totalPrice = originalPrice + totalExtrasPrice;

    // Aktualizovat zobrazení
    updatePriceDisplay(totalPrice);

    console.log('LK Custom JS: Price updated -', 'Selected:', selectedCount, 'Original:', originalPrice, 'Extras:', totalExtrasPrice, 'Total:', totalPrice);
  }

  /**
   * Aktualizuje zobrazení ceny v DOM
   * @param {number} price - Cena v eurech
   */
  function updatePriceDisplay(price) {
    // Formátovat cenu (€52,95 - s čárkou)
    const formattedPrice = formatPrice(price);

    // Aktualizovat text v price elementu
    if (priceElement) {
      priceElement.textContent = formattedPrice;
    }

    // Aktualizovat content atribut (používá tečku pro schema.org)
    if (priceContentElement) {
      priceContentElement.setAttribute('content', price.toFixed(2));
    }
  }

  /**
   * Formátuje cenu podle detekovaného formátu měny
   * @param {number} price - Cena
   * @returns {string} Formátovaná cena
   */
  function formatPrice(price) {
    // Formátovat s 2 desetinnými místy
    let priceString = price.toFixed(2);

    // Použít správný desetinný separator
    if (priceFormat.decimalSeparator === ',') {
      priceString = priceString.replace('.', ',');
    }

    // Přidat měnový symbol na správnou pozici
    if (priceFormat.symbolBefore) {
      return priceFormat.symbol + priceString;
    } else {
      return priceString + priceFormat.symbol;
    }
  }

  // Spustit po načtení DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
